const CUISINE_TYPE_INITIAL_STATE = {
  isFetchLoading: false,
  fetchError: undefined,
  isSimpleDetailsLoading: false,
  simpleDetailsError: undefined,
  isImageDetailsLoading: false,
  imageDetailsError: undefined,
  data: undefined,
}

export default CUISINE_TYPE_INITIAL_STATE
